export default "__VITE_ASSET__9cef9aaa__"